<div>
    <a href="#" [routerLink]="['/', 'metal-order']" routerLinkActive="disabled" [routerLinkActiveOptions]="{ exact: true }" class="button">
        {{ 'btn-buy-metals' | translate }}
    </a>

    <i class="pi pi-star-fill icon-1"></i>
    <i class="pi pi-star-fill icon-2"></i>
    <i class="pi pi-star-fill icon-3"></i>
</div>
